import React, { useState, useEffect, useRef, useContext } from 'react';
import ReactModal from 'react-modal';
import Pusher from 'pusher-js';
import './channels.css'
import axios from "axios";
import SglContext from "../SglContext";
import {Link, useSearchParams } from 'react-router-dom';
import play from '../images/play19.png';
import horse_logo from '../images/horse-logo.png'
import VideoSubscription from "../videos/VideoSubscription";
import JWPlayer from '@jwplayer/jwplayer-react';
import { initGtagIframe, sendGtagPageView, destroyGtagIframe } from '../utils/gtagIframe';

var AddModal = ReactModal;
var check_channel_status;

function LivestremDetail() {
    const [is_user_authorized, setIs_user_authorized] = useState(false);
    const [channel_subscribed, setChannel_subscribed] = useState(false);
    const [channel_is_live, setChannel_is_live] = useState(false);
    const [current_channel, setCurrent_channel] = useState({});
    const [total_rows, setTotal_rows] = useState(0);
    const [channels_list, setChannels_list] = useState([]);
    const [stream_link, setStream_link] = useState('');
    const [timeout, setTimeoutState] = useState(null);
    const [is_open_do_subscription_modal, setIs_open_do_subscription_modal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState({});
    const [login_people_id, setLogin_people_id] = useState(-1);
    const [videos_list, setVideos_list] = useState([]);
    const [total_videos, setTotal_videos] = useState(0);
    const [video_to_play, setVideo_to_play] = useState(null);
    const [searchParams] = useSearchParams();
    const sgl_live_channel_id = searchParams.get('live_channel');

    const VideoSubscriptionElement = useRef(null);
    const gtagIframeRef = useRef(null);

    const Sgl = useContext(SglContext)
    const sgl_webservice_channels_list = Sgl.nestApiUrl + "/channels";
    const user_info_url = Sgl.nestApiUrl + "/users/getLoggedInUser";
    const sgl_webservice_check_live = Sgl.sglApiUrl+'/iphonev2.php/videosv2/IsChannelLive';
    const sgl_webservice_video_assets = Sgl.nestApiUrl + "/video-assets";
    const sgl_webservice_videos = Sgl.sglApiUrl+'/iphonev2/videosv2/';

    useEffect(() => {
        // Initialize iframe ONCE
        const videoTrackingId = Sgl.ga_video_tracking_id;
        if (videoTrackingId && !gtagIframeRef.current) {
            gtagIframeRef.current = initGtagIframe(videoTrackingId);
        }

        getAllData();

        // Add beforeunload event listener
        window.addEventListener("beforeunload", handleBeforeUnload);
        
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);

            destroyGtagIframe();
        };
    }, []);

    const handleBeforeUnload = (e) => {
        logVideoPlayback('video closed');
    };

    const getAllData = () => {
        var live_ring_subs = 0;
        var switches = Sgl.switches.switches;
        var switch_found = switches.find(el => el.switch_name === "Live Ring Subscription");
        if(switch_found){
            live_ring_subs = switch_found.value;
        }
        if(live_ring_subs){
            getUserData();
        }

        getChannelsData();
        checkChannelSubscription();
    };
  
    const getChannelsData = () => {
        axios
        .get(sgl_webservice_video_assets + '/getLiveRingStreamsList', {
            params: {
                channel_type: 'livestream',
                customer_id: Sgl.company_id,
            },
        })
        .then((res) => {
            var current_channel = res.data.channels_list.find(el => (el.sgl_id == sgl_live_channel_id));
            document.title = `${Sgl.company_urlpath.toUpperCase()} - ${current_channel.name}`;

            // Send gtag event via iframe
            setTimeout(() => {
                if (gtagIframeRef.current) {
                    sendGtagPageView(gtagIframeRef.current, {
                        page_path: '/sgl-wp-plugin/'+Sgl.company_urlpath+'/channels/live/detail/'+sgl_live_channel_id,
                        page_title: document.title
                    });
                }
            }, 1500);

            Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/channels/live/detail/'+sgl_live_channel_id);
            Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/channels/live/detail/'+sgl_live_channel_id);
            setChannels_list(res.data.channels_list);
            setTotal_rows(res.data.total_records);
            setCurrent_channel(current_channel ? current_channel : {});
        });
    };

    const checkChannelSubscription = () => {
        axios
        .get(sgl_webservice_channels_list + '/checkSubscription', {
            params: {
                customer_id: Sgl.company_id,
            },
        })
        .then((res) => {
            setChannel_subscribed(res.data.channel_subscribed);
            setLoading(false);
            
            if(res.data.channel_subscribed){
                getVideoPlaylist();
                var pusher = new Pusher('b6232310f51498462640');
                var channel = pusher.subscribe('video_channel_'+sgl_live_channel_id);
                channel.bind('updateavailable', function(status) {
                    console.log(status);
                    if(status == 'Online'){
                        setTimeout(function(){
                            setChannel_is_live(true);
                            // setupChannelPlayer();
                            if(check_channel_status){
                                clearInterval(check_channel_status);
                            }
                        },1000*60);
                    }else{
                        setChannel_is_live(false);
                    }
                });
            } else {
                openSubscriptionModal();
            }
        });
    };

    const getVideoPlaylist = () => {
        axios
        .get(sgl_webservice_video_assets + '/getLiveStreamDetail', {
            params: {
                channel_id: sgl_live_channel_id,
                customer_id: Sgl.company_id,
            },
        })
        .then((res) => {
            setChannel_subscribed(res.data.channel_subscribed);
            setVideos_list(res.data.playlist);
            setTotal_videos(res.data.total_videos);
            
            if(res.data.channel_subscribed){
                checkIsChannelLive();
            }
            
            if(res.data?.special_event_id) {
                // redirect if special event found
                window.location.href = `${window.location.protocol}//${window.location.host}${(Sgl.basePath != '/' && Sgl.basePath != '') ? `${Sgl.basePath}` : ""}`+`/livestream/detail?se_id=${res.data.special_event_id}`;
            }
        });
    };

    // const setupChannelPlayer = () => {
    //     window.jwplayer("myDetailElement")
    //         .setup({ 
    //             "playlist": videos_list,
    //             "width": '100%',
    //             "height": '100%',
    //             ga:{},
    //         })
    //         .on('playlistItem', function changePlayingVideo(item){
    //             setVideo_to_play(item.item);
    //             logVideoPlayback('video played');
    //             Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/channels/live/playback/'+item.item.mediaid);
    //         });
    //     window.jwplayer("myDetailElement").onReady(function(){
    //         window.jwplayer("myDetailElement").playlistItem(0);
    //     });

    //     window.jwplayer("myDetailElement").on('play', () => {
    //         logVideoPlayback('video resumed');
    //     });

    //     window.jwplayer("myDetailElement").on('pause', () => {
    //         logVideoPlayback('video paused');
    //     });

    //     window.jwplayer("myDetailElement").on('remove', () => {
    //         logVideoPlayback('video closed');
    //     });
    // };

    const getUserData = () => {
        axios.get(user_info_url).then(
        (response) => {
            Sgl.checkLoginOnSGL();
            if (response.data.user && response.data.user != null) {
                setUserData(response.data.user);
                setLogin_people_id(response.data.user.sgl_id);
            }
        },
        (error) => {}
        );
    };

    const checkIsChannelLive = () => {
        var d = new Date();
        axios
        .get(sgl_webservice_check_live, {
            params: {
                id: sgl_live_channel_id,
                d: d.getTime(),
            },
        })
        .then((res) => {
            if(res.data == 'Online'){
                setChannel_is_live(true);
                // setupChannelPlayer();
                
                if(check_channel_status){
                    clearInterval(check_channel_status);
                }
            } else {
                setChannel_is_live(false);

                if(!check_channel_status){
                    check_channel_status = setInterval(checkIsChannelLive, 1000*120);
                }
            }
        },
        (error) => {
            
        });
    };

    //////////// subscription functions /////////
    const openSubscriptionModal = () => {
        setIs_open_do_subscription_modal(true);
    };

    const closeDoSubscriptionModal = () => {
        setIs_open_do_subscription_modal(false);
    };

    const playVideoAfterSubscribe = () => {
        closeDoSubscriptionModal();
    };
    //////////// end subscription functions /////////

    const logVideoPlayback = (video_state) => {
        let browser = getBrowserInfo();
        axios
        .get(sgl_webservice_videos+'LogVideoPlayback', {
            params: {
                video_asset_id: sgl_live_channel_id,
                customer_id: Sgl.company_id,
                browser_info: browser,
                isMobile: Sgl.is_mobile,
                is_iphone: false,
                state: video_state,
                from_wp_api: true,
            },
        })
        .then(
            (response) => {
                
            },
            (error) => {}
        );
    };

    const getBrowserInfo = () => {
        var sBrowser;
        var sUsrAg = window.navigator.userAgent;
    
        if (sUsrAg.indexOf("Firefox") > -1) {
            sBrowser = "Mozilla Firefox";
        } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
            sBrowser = "Samsung Internet";
        } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
            sBrowser = "Opera";
        } else if (sUsrAg.indexOf("Trident") > -1) {
            sBrowser = "Microsoft Internet Explorer";
        } else if (sUsrAg.indexOf("Edge") > -1) {
            sBrowser = "Microsoft Edge";
        } else if (sUsrAg.indexOf("Chrome") > -1) {
            sBrowser = "Google Chrome or Chromium";
        } else if (sUsrAg.indexOf("Safari") > -1) {
            sBrowser = "Apple Safari";
        } else {
            sBrowser = "unknown";
        }
        return sBrowser;
    };

    const loading_state = loading;
    let inIframe = false;
    if(window.location !== window.parent.location){
        inIframe = true;
    }

    if (loading_state) {
        return null;
    }

    return (
        <div className="sgl-plugin livestreamcss">
            <h1>{current_channel.name}</h1>
            <h3>{current_channel.description}</h3>
            <div className="credit-text">{process.env.REACT_APP_CREDIT_TEXT} <a href={process.env.REACT_APP_CREDIT_URL}>{process.env.REACT_APP_CREDIT_COMPANY}</a></div><br/>
            <div className='video_player'>
                {(!channel_subscribed || !channel_is_live) &&
                    <div className='channel_thumbnail'>
                        <a onClick={() => !channel_subscribed ? openSubscriptionModal() : checkIsChannelLive()} className="play-wrapper">
                            <img className='channel_img' src={current_channel.logo} />
                            <div className='red channel_status'>OFFLINE</div>
                            <span className="play-button">
                                <span className="play">
                                    <img src={play} />
                                </span>
                            </span>
                        </a>
                    </div>
                }
                {(channel_subscribed && channel_is_live) &&
                    <div className='green channel_live'>LIVE</div>
                }
                {(channel_subscribed && channel_is_live && videos_list.length > 0) &&
                    <div id="myDetailElement">
                        <JWPlayer
                            config={{ width: '100%', height: '100%' }}
                            playlist={videos_list}
                            library={"https://cdn.jwplayer.com/libraries/hMVctbog.js"}
                            onPlaylistItem={(event) => {
                                setVideo_to_play(event.item);
                                logVideoPlayback('video played');
                                Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/channels/live/playback/'+event.item.mediaid);
                                Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/channels/live/playback/'+event.item.mediaid);
                            }}
                            onPlay={() => logVideoPlayback('video resumed')}
                            onPause={() => logVideoPlayback('video paused')}
                            onComplete={() => logVideoPlayback('video completed')}
                        />
                    </div>
                }
            </div>
            <div
                id="videos_listing"
                className="detail_grid"
            >
                <div className="related-videos-header header-bg">
                    latest Live Ring Streams 
                </div>
                <div className="flex-video-container">
                    {total_rows > 0 ? (
                        channels_list.map((channel, index) => {
                            return (
                                <div key={index} className="video_container">
                                    <div className="video-content">
                                        <div className="thumb-image">
                                            <Link className='cursor-pointer' to={'/live-channels/detail?live_channel='+channel.sgl_id}>
                                                <img src={channel.logo} />
                                                <div className={(channel.status == 'Online') ? 'green channel_status' : 'red channel_status'}>
                                                    {(channel.status == 'Online') ? "LIVE" : "OFFLINE"}
                                                </div>
                                            </Link>
                                        </div>
                                        <div className="video_details">
                                            <div>
                                                <Link className='cursor-pointer' to={'/live-channels/detail?live_channel='+channel.sgl_id}>
                                                    <span className="channel_details link_color">
                                                        {channel.name}
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="video_container">
                            <div className="video-content">
                                <div className="thumb-image">
                                    <span className="float-left">No channels Found</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <AddModal
                isOpen={is_open_do_subscription_modal}
                onRequestClose={closeDoSubscriptionModal}
                className={"mymodal subscription-modal" + (inIframe ? ' subscription-in-iframe' : '')}
                overlayClassName="myoverlay"
                ariaHideApp={false}
            >
                <VideoSubscription 
                    is_download_subscription={false} 
                    is_video_subscription={true}
                    subscription_type={'channel'}
                    video_to_play={{videos_sgl_id:-1}}
                    closeSubscriptionModal={closeDoSubscriptionModal}
                    playVideoAfterSubscribe={playVideoAfterSubscribe}
                    ref={VideoSubscriptionElement}
                />
            </AddModal>
            <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
        </div>
    );
}

export default LivestremDetail